/* eslint-disable check-file/filename-blocklist */
import { defineMessages } from 'react-intl';

export const i18n: {
	statusLabel: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	changeStatus: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	setPageStatus: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	setBlogStatus: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	addCustomStatus: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	custom: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	suggested: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	save: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	cancel: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	remove: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	showMoreStatuses: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	maxLengthEditor: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	featureDisabled: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	errorFlagTitle: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	errorFlagBody: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	removeErrorFlagTitle: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	removeErrorFlagBody: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	noneText: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	colorOptionAriaLabel: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	colorPickerButtonAriaLabel: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	removeButtonAriaLabel: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	changeStatusButtonAriaLabel: {
		id: string;
		description: string;
		defaultMessage: string;
	};
} = defineMessages({
	statusLabel: {
		id: 'content-state.add-status.floating-toolbar',
		description:
			'Text in the button to prompt user to add content state when they hover over the title in editor from the floating toolbar.',
		defaultMessage: 'Status',
	},
	changeStatus: {
		id: 'content-state.change-status',
		description: 'Message in tooltip when user hovers over existing content state',
		defaultMessage: 'Change status',
	},
	setPageStatus: {
		id: 'content-state.set-page-status',
		description: 'Title of modal where user can customize their content state if content is a page',
		defaultMessage: 'Set status',
	},
	setBlogStatus: {
		id: 'content-state.set-blog-status',
		description:
			'Title of modal where user can customize their content state if content is a blog post',
		defaultMessage: 'Set blog post status',
	},
	addCustomStatus: {
		id: 'content-state.add-custom-status',
		description: 'Placeholder in textfield which prompts users to add a custom content state',
		defaultMessage: 'Add custom status',
	},
	custom: {
		id: 'content-state.custom',
		description: 'Heading of modal section which lists the custom content states',
		defaultMessage: 'Custom',
	},
	suggested: {
		id: 'content-state.suggested',
		description: 'Heading of modal section which lists the suggested content states',
		defaultMessage: 'Suggested',
	},
	save: {
		id: 'content-state.save',
		description: 'Button user clicks on to save content state they created',
		defaultMessage: 'Save',
	},
	cancel: {
		id: 'content-state.cancel',
		description: 'Button user clicks on to cancel creation of content states',
		defaultMessage: 'Cancel',
	},
	remove: {
		id: 'content-state.remove',
		description: 'Text on button to remove the current content state',
		defaultMessage: 'Remove',
	},
	showMoreStatuses: {
		id: 'content-state.show.more.statuses',
		defaultMessage: 'Show more statuses',
		description:
			'Label of chevron icon for content state button that displays additional statuses when clicked.',
	},
	maxLengthEditor: {
		id: 'content-state.max.length.editor.creation',
		description:
			'Message under textfield that says only 20 characters is allowed for the content state name',
		defaultMessage: 'Max length of 20',
	},
	featureDisabled: {
		id: 'content-state.feature.disabled.message',
		description:
			'Message in the modal that displays if the content state feature is disabled in the space.',
		defaultMessage: 'The content status feature is not enabled in this space.',
	},
	errorFlagTitle: {
		id: 'content-state.error.flag.title',
		description: "Error flag title when we can't set the content state",
		defaultMessage: 'We can’t set your status',
	},
	errorFlagBody: {
		id: 'content-state.error.flag.body',
		description: "Message in error flag body when we can't set the content state.",
		defaultMessage: 'Refresh and try again.',
	},
	removeErrorFlagTitle: {
		id: 'content-state.remove-error.flag.title',
		description: "Error flag title when we can't remove the content state",
		defaultMessage: 'Failed to remove content state',
	},
	removeErrorFlagBody: {
		id: 'content-state.remove-error.flag.body',
		description: "Message in error flag body when we can't remove the content state.",
		defaultMessage: 'Refresh and try again.',
	},
	noneText: {
		id: 'content-state.none.text',
		description: 'Message in Publish Modal indicating if the user has no active content state.',
		defaultMessage: 'None',
	},
	colorOptionAriaLabel: {
		id: 'content-state.color-option.aria-label',
		description: 'Aria label for color picker option button',
		defaultMessage: '{colorName} color option',
	},
	colorPickerButtonAriaLabel: {
		id: 'content-state.color-picker-button.aria-label',
		description:
			'Aria label for color picker button that conveys its purpose and the currently selected color',
		defaultMessage: 'Color picker, {colorName} selected',
	},
	removeButtonAriaLabel: {
		id: 'content-state.remove-button.aria-label',
		description:
			'The text is used as the accessible aria-label for the remove button that appears next to a content status in the editor, allowing the user to clear or remove the currently applied status from the page.',
		defaultMessage: 'Remove status',
	},
	changeStatusButtonAriaLabel: {
		id: 'content-state.change-status-button.aria-label',
		description:
			'Accessible label for the content state button in the editor byline. Conveys both the action (Change Status) and the current status name to screen reader users.',
		defaultMessage: 'Change Status: {statusName}',
	},
});
